import { useTemplateData } from 'src/Context/TemplateData.context';
import SingleOption from './SingleObject';

type ISelectSubjectProps = {};

const SelectSubject = ({}: ISelectSubjectProps) => {
  const { selectedSubject, setSelectedSubject, subjects, setValidationError } =
    useTemplateData();

  const handleSelect = (id: number | string) => {
    setValidationError('');
    setSelectedSubject(id as string);
  };

  return (
    <div className="subjects">
      {subjects.map(item => {
        return (
          <SingleOption
            key={item.id}
            handleSelect={handleSelect}
            item={item}
            selected={selectedSubject}
          />
        );
      })}
    </div>
  );
};

export default SelectSubject;
